import {connect} from 'react-redux';
import {Component} from 'react';
import classNames from 'classnames';
import injectSheet from 'react-jss';

import Modal from '-/components/general/Modal';
import AuthDateInput from '-/components/fields/AuthDateInput';
import {authenticate} from '-/util/authenticate';
import FunnelService from '-/services/FunnelService';
import validationStyles from '-/styles/sections/validation';
import {get} from '-/util/lodash';

const styles = theme => ({
    ...validationStyles(theme)
});

class VerifyDob extends Component {
    constructor(props) {
        super(props);
        this.fieldRefs = {};

        this.state = {
            formError: '',
            showErrorMsg: false
        };
    }

    componentWillReceiveProps(nextProps) {
        if (typeof nextProps.validated === 'boolean') {
            this.setState({showErrorMsg: !nextProps.validated});
        }
    }

    // How far the member got if they leave this screen without authenticating. This is
    // the only place abandonment inside the auth step is visible - a character count,
    // never the value.
    componentWillUnmount() {
        if (this.props.validated === true) {
            return;
        }

        FunnelService.authFieldProgress('dob', 'dob', get(this, 'fieldRefs.input.value', ''));
    }

    handleSubmit = () => {
        const {authenticate} = this.props;
        const fieldDate = get(this, 'fieldRefs.input.value', '');
        let formError;

        if (!fieldDate) {
            formError = 'You must provide a day, month, and year before authenticating.';
            FunnelService.authFieldProgress('dob', 'dob', fieldDate);
        } else {
            authenticate('dob', fieldDate);
        }

        this.setState({
            formError
        });
    };

    handleKeyDown = () => {
        this.handleSubmit();
    };

    render() {
        const {validated, classes = {}} = this.props;
        const {formError, showErrorMsg} = this.state;
        const checkClassNames = classNames(classes.verifyIcon, {
            [classes.verifyIconSuccess]: validated === true,
            [classes.verifyIconFail]: validated === false
        });

        return (
            <Modal className="verify-dob" onClick={this.handleSubmit}>
                <section className={classes.description}>
                    <div className={classes.icon}>
                        <i className="fa fa-birthday-cake" alt="Birthday Cake" />
                        {validated !== null ? <span className={checkClassNames} /> : null}
                    </div>
                    <div className={classes.text}>
                        <h3>Verify Date of Birth</h3>
                        {formError && <h4 className={classes.errorText}>{formError}</h4>}
                        {showErrorMsg ? (
                            <h4 className={classes.errorText}>Your date of birth doesn&#8217;t match what we have on file.</h4>
                        ) : null}
                    </div>
                </section>
                <div className="masked-form">
                    <div className="control">
                        <AuthDateInput innerRef={ref => this.fieldRefs.input = ref} onEnterKey={this.handleKeyDown} />
                    </div>
                </div>
            </Modal>
        );
    }
}

const mapStateToProps = (state) => {
    const {validated} = state.validationInfo;
    return {validated};
};

export default connect(mapStateToProps, {authenticate})(injectSheet(styles)(VerifyDob));
